import { useEffect, useState } from "react"
import { useSearchParams } from "react-router";
import { getFactPDF } from "../../Fetch/GetComp";
import ObjectPDF from "../../Components/PDF/ObjectPDF";
import { useNavigate } from "react-router"
import Loading from "../../Components/Loading/Loading";
import './desglose.css'
export default function FactView() {

  const [searchParams] = useSearchParams();
  let navigate = useNavigate();
  const [Comp, setComp] = useState({
    pdf: []
  })


  useEffect(() => {
    document.title = searchParams.get("uuid");
    getFactPDF(searchParams.get("uuid"), searchParams.get("hash")).then(res => {
      if (res.valid) {
        localStorage.setItem("ContaKMPCot", res.token);
        setComp(v => ({
          ...v,
          pdf: res.data.payload.map((Fact) => (
            {
              ...v.pdf,
              pdf: 'data:application/pdf;base64,' + Fact.pdf,
              uuid: Fact.UUID
            }
          ))
        }))
      } else {
        localStorage.removeItem("ContaKMPCot")
        navigate("/")
      }
    })
  }, [searchParams, navigate])

  return (
    <div className="Factview">
      {
        Comp.pdf.length > 0 ?
          Comp.pdf.map((el, ind) => (
            <ObjectPDF key={ind} data={`${el.pdf}`}>ObjetoPDF</ObjectPDF>
          ))
          :
          <Loading />
      }
    </div>
  )
}